import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { getStyle } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import CBSearchInput from '../../shared/CBSearchInput';
import CBButtonAddCar from '../../shared/CBButtonAddCar';
import CBButtonGarageAction from '../../shared/CBButtonGarageAction';
import CBSelectFilters from '../../shared/CBSelectFilters';
import CBSelectField from '../../shared/form_components/CBSelectField';
import CBLabelAndCheckbox from '../../shared/CBLabelAndCheckbox';


class TaskFilterBar extends Component {
  getStatusOptions = () => {
    return [
      {
        label: this.props.t('filterShowAll'),
        value: ''
      },
      {
        label: this.props.t('filterShowCreated'),
        value: 'created'
      },
      {
        label: this.props.t('filterShowInProgress'),
        value: 'in_progress'
      },
      {
        label: this.props.t('filterShowCompleted'),
        value: 'done'
      },
      {
        label: this.props.t('filterShowCancelled'),
        value: 'cancelled'
      },
    ]
  }

  render() {
    const {
      useIdentifiers,
      changeSearchTerms,
      changeFilterTerms,
      refetchTasks,
      addTask,
      filters,
      search,
      t,
    } = this.props;

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'containerFilters')}>
              <div style={getStyle(screenSize, styles, 'containerSearch')}>
                <CBSearchInput
                  containerStyle={{ height: 40, width: 200, marginLeft: 0, marginRight: 0}}
                  changeSearchTerms={changeSearchTerms}
                  onBlur={() => refetchTasks(null, null, null, 1)}
                  value={search}
                />
                {
                  useIdentifiers && (
                    <CBLabelAndCheckbox
                      labelText={t('searchIdentifiersOnly')}
                      checked={filters.search_identifiers}
                      onChange={
                        () => {
                          const newFilters = {...filters};
                          if (!filters.search_identifiers) {
                            return changeFilterTerms({...newFilters, search_identifiers: true })
                          } else {
                            delete newFilters.search_identifiers;
                            return changeFilterTerms({...newFilters})
                          }
                        }
                      }
                    />
                  )
                }
              </div>
              <CBSelectFilters
                name='status'
                options={this.getStatusOptions()}
                onChange={changeFilterTerms}
                value={filters.status}
                selectStyle={{width: 200, marginLeft: 0}}
              />
            </div>
            <div style={getStyle(screenSize, styles, 'containerActions')}>
              <CBButtonGarageAction
                onClick={addTask}
                text={t('headingAddTask')}
                additionalIcon='/img/icon_plus.svg'
                mainIcon='/img/icon_task_list.svg'
                additionalStylesMainIcon={{ height: 25, width: 25 }}
              />
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    containerSearch: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
    },
    containerFilters: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      gap: 12,
    },
    containerActions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
  },
};

function mapStateToProps(state) {
  return {
    searchRequest: state.search,
  };
}

export default connect(
  mapStateToProps,
  {
  },
)(translate('TaskListView')(TaskFilterBar));
